var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefresh = function SvgRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-20": 14,
    "data-width-24": 17,
    viewBox: "0 0 16.4 16.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8.391c-.007-3.317 2.113-6.53 6.135-8.33a.7.7 0 1 1 .572 1.278C3.092 2.957 1.394 5.724 1.4 8.388c.005 2.116 1.085 4.299 3.355 5.918L3.17 11.277a.7.7 0 1 1 1.24-.65l2.668 5.097a.7.7 0 0 1-.62 1.055H1.86a.7.7 0 1 1 0-1.4H3.85C1.324 13.537.006 10.996 0 8.39m16.4-.003c.008 3.316-2.113 6.53-6.135 8.33a.7.7 0 0 1-.571-1.278c3.614-1.618 5.312-4.385 5.306-7.049-.005-2.116-1.085-4.299-3.355-5.918l1.585 3.029a.7.7 0 1 1-1.24.649L9.323 1.055A.7.7 0 0 1 9.943 0h4.598a.7.7 0 1 1 0 1.4h-1.992c2.527 1.842 3.845 4.383 3.851 6.988",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export default ForwardRef;